import { render } from "./MainButton.vue?vue&type=template&id=381cd6e6&scoped=true"
import script from "./MainButton.vue?vue&type=script&lang=js"
export * from "./MainButton.vue?vue&type=script&lang=js"

import "./MainButton.vue?vue&type=style&index=0&id=381cd6e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381cd6e6"]])

export default __exports__